import React from 'react';

import ToggleButton from './ToggleButton';
import SelectType from './SelectType';
import Control from '../Control';
import TYPES from './types';

const initialState = {
  visible: false,
  control: null,
};

export class AddControl extends React.Component {
  state = { ...initialState }

  get Step () {
    const { visible, control } = this.state;

    if (control) {
      return Control;
    }

    if (visible) {
      return SelectType;
    }

    return ToggleButton;
  }

  toggle = () =>
    this.setState(({ visible, ...state }) =>
      ({ ...state, visible: !visible, control: null }));

  displayForm = ({ label, ...control }) => () => this.setState({ control });

  add = control => {
    const { onAdd = () => null } = this.props;
    onAdd(control);
    this.reset();
  }

  reset () {
    this.setState({ ...initialState });
  }

  render () {
    const { controls } = this.props;
    const { control } = this.state;
    const { toggle, displayForm, add, Step } = this;
    const types = TYPES.filter(({ type, unique }) => (unique
      ? !controls.find(({ type: cType }) => cType === type)
      : true));

    return (
      <div className="add-control">
        <Step
          controls={controls}
          toggle={toggle}
          displayForm={displayForm}
          onSave={add}
          saveLabel="Ajouter"
          initInvalid
          types={types}
          adding
          onRemove={toggle}
          control={control}
        />
      </div>
    );
  }
}
export default AddControl;



// WEBPACK FOOTER //
// ./src/components/Admin/ActivitiesManagement/ActivityEdit/AddControl/index.js